export default "__VITE_ASSET__C$EN4Asz__"